type GoAiguaCheckboxProps = {
  checkedStatus: "not-checked" | "checked" | "partially-checked";
  setCheckedStatus: () => any;
};

const GoAiguaCheckbox: React.FC<GoAiguaCheckboxProps> = ({
  checkedStatus = "none",
  setCheckedStatus,
}) => {
  const toggleCheckboxBackgroundWithCssPseudoAttributes = () => {
    if (checkedStatus === "not-checked") {
      return { checked: false, onChange: () => void 0 };
    } else {
      return { checked: true, onChange: () => void 0 };
    }
  };

  const generateAfterElement = () => {
    if (checkedStatus === "checked") {
      return " --checked";
    } else if (checkedStatus === "partially-checked") {
      return " --partially-checked";
    } else {
      return "";
    }
  };

  return (
    <div className="c-goaigua-checkbox">
      <div
        className={"c-goaigua-checkbox__input-container"}
        onClick={setCheckedStatus ? () => setCheckedStatus() : void 0}
      >
        <div
          className={
            "c-goaigua-checkbox__checkbox " + generateAfterElement()
          }
        >
          <input
            type="checkbox"
            {...toggleCheckboxBackgroundWithCssPseudoAttributes()}
          />
        </div>
      </div>
    </div>
  );
};

export default GoAiguaCheckbox;
